module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Gd-Hc-Ib-Ja.46b6a13e.png";